import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { fetchBlogs } from "../utils/firebaseFunctions";
import homebackground from './../image/banner.png';
import { Helmet } from 'react-helmet';
import { Loader } from ".";
const BlogDetails = () => {
  const { id } = useParams(); // Get the blog ID from the URL
  const [{ Blog }, dispatch] = useStateValue(); // Access blog state
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getBlogData = async () => {
      if (!Blog || Blog.length === 0) {
        await fetchBlogs(dispatch); // Fetch blogs if state is empty
      }
    };
    getBlogData();
  }, [dispatch, Blog]);

  useEffect(() => {
    if (Blog && Blog.length > 0) {
      const selectedBlog = Blog.find((b) => b.id === id);
      setBlog(selectedBlog);
    }
    setLoading(false);
  }, [id, Blog]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader />
      </div>
    );
  }
  if (!blog) {
    return <p className="text-center mt-10 text-[20px] text-gray-500">Blog not found</p>;
  }

  return (
    <div className={`w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0 `}>
    {/* Meta Tags for SEO */}
    <Helmet>
      <title>Our Blogs - Nexify Infosystems</title>
      <meta
        name="description"
        content="Stay updated with the latest insights, trends, and news from Nexify Infosystems. Explore our blogs on technology, business solutions, and innovation."
      />
      <meta
        name="keywords"
        content="Nexify, blogs, technology insights, business trends, innovation, IT solutions"
      />
    </Helmet>
    <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${homebackground})` }}
      >
        {/* Black Overlay */}
        {/* <div className="absolute inset-0 bg-black opacity-50"></div> */}
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
            <div
              className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
              style={{
                animation: "slideUp 1s ease-in-out forwards",
                animationDelay: "2s",
              }}
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>
            <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
               Nexify Blog
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
  Insights & Innovations for Your Business Growth
</h2>

          </div>
        </div>
      </div>
    <div className="max-w-4xl mx-auto px-4 py-10">
      <img src={blog.imageurl} alt={blog.title} className="w-full h-full object-cover rounded-lg" />
      <h1 className="text-3xl font-bold mt-6 text-gray-900">{blog.title}</h1>
      <p className="text-gray-600 text-sm mt-2">{blog.date}</p>
      <p className="text-[#6d6d70] mt-6 text-[16px] leading-7">{blog.description}</p>
    </div>
    </div>
  );
};

export default BlogDetails;
